import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { MailFilterNavigation } from '../../../shared/enum/mail-filter-navigation.enum';

export interface MailFolderItem {
  idMailFolder: number;
  name: string;
  messageCount: number;
}

@Component({
  selector: 'app-email-filter',
  templateUrl: './email-filter.component.html',
  styleUrls: ['./email-filter.component.scss'],
})
export class EmailFilterComponent implements OnInit {

  @Input() NotReadCount: number;
  @Input() readCount: number;
  @Input() inboxCount: number;
  @Input() outBoxCount: number;
  @Input() starredCount: number;
  @Input() starredApplicationsCount: number;
  @Input() starredOthersCount: number;
  @Input() customFolders: MailFolderItem[] = [];
  @Input() selectedFolderId: number | null = null;
  @Output() navigate: Subject<MailFilterNavigation> = new Subject();
  @Output() navigateToFolder = new EventEmitter<number>();
  @Output() openFolderManagement = new EventEmitter<void>();
  public open: boolean = false;

  public navigation = MailFilterNavigation;
  constructor() {}

  openMenu() {
    this.open = !this.open;
  }
  ngOnInit(): void { }

  public onNavigate(select: MailFilterNavigation) {
    this.navigate.next(select);
  }

  public onNavigateToFolder(folderId: number): void {
    this.navigateToFolder.emit(folderId);
  }

  public onOpenFolderManagement(): void {
    this.openFolderManagement.emit();
  }
}
